import React, { Component } from 'react';
import { Spinner } from 'src/components/Spinner';
import Progress from './Progress/Progress';
import TabContent from './TabContent';
import OrderSummary from './OrderSummary';
import './StepCheckout.scss';
import StudentPreviewControls from '../../Course/Stages/Lessons/StudentPreviewController/StudentPreviewControls';
import { RouteComponentProps, withRouter } from 'src/hoc/withRouter';
import { adminSettingsAPI } from 'src/helpers/new/ApiService';

export interface TermsAndConditionsParams {
    value: string;
    type: string;
}

interface IProps extends RouteComponentProps {
    currentTab: number;
    isAdminPreview: boolean;
    state: string;
    onSetTermsAndConditions: (params: TermsAndConditionsParams) => void;
    pkgTermsConditionsCheckboxToggle: (value: string) => void;
    status: string;
}
interface IState {}
class Checkout extends Component<IProps, IState> {
    state = {};

    onTermsAndConditions = async () => {
        const { response, success } = await adminSettingsAPI.getTermsOfService();

        this.props.onSetTermsAndConditions({ value: success ? response : 'Failed to load', type: 'terms' });
    };

    onPrivacyPolicy = async () => {
        const { response, success } = await adminSettingsAPI.getPrivacyPolicy();

        this.props.onSetTermsAndConditions({ value: success ? response : 'Failed to load', type: 'privacyPolicy' });
    };

    render() {
        const { currentTab, isAdminPreview, state, status } = this.props;
        return (
            <div className={`checkout-container ${currentTab === 3 ? 'checkout-payment-container' : ''}`}>
                {isAdminPreview && (
                    <div className='checkout-page-preview-settings-container'>
                        <StudentPreviewControls isCheckout={true} />
                    </div>
                )}
                <h1 className='heading'>
                    The fastest and most affordable way to become a licensed real estate agent and mortgage loan
                    originator
                    {state ? ` in ${state}` : ''}!
                </h1>
                <div className={`checkout-main ${currentTab === 3 ? 'checkout-payment-stage' : ''}`}>
                    {status === 'LOADING' ? (
                        <Spinner />
                    ) : (
                        <>
                            {status === 'EMPTY' && (
                                <>
                                    <h4>Your cart is empty</h4>
                                    <a href='https://realestateu.com/' target='_blank' rel='noreferrer'>
                                        Browse our packages
                                    </a>
                                </>
                            )}
                            {status === 'READY' && (
                                <>
                                    <OrderSummary />
                                    <Progress />
                                    <TabContent
                                        onSetTermsAndConditions={this.props.onSetTermsAndConditions}
                                        pkgTermsConditionsCheckboxToggle={this.props.pkgTermsConditionsCheckboxToggle}
                                    />
                                </>
                            )}
                        </>
                    )}
                </div>
                {status !== 'LOADING' && (
                    <div className={`checkout-consent-text ${currentTab === 3 ? 'mt-0 pt-0' : ''}`}>
                        <div className='consent-text'>
                            <p>
                                By continuing, I agree to provide my personal details, such as my phone number, to
                                receive promotional and informational communications via emails, automated calls, text
                                messages, and pre recorded voicemails. These may cover current or potential future
                                services, customer support, and billing matters. By doing so, I accept the{' '}
                                <button onClick={this.onTermsAndConditions} className='consent-link'>
                                    Terms of Service
                                </button>{' '}
                                &amp;{' '}
                                <button onClick={this.onPrivacyPolicy} className='consent-link'>
                                    Privacy Policy
                                </button>
                                {''}. I acknowledge that I can opt out of receiving texts or electronic messages at any
                                time by replying STOP to cancel or HELP for assistance. Message and data rates may
                                apply. To unsubscribe from emails, I will follow the instructions in the email
                                communication. I understand that my agreement to these terms is not a condition of any
                                purchase and that canceling a purchase does not automatically revoke this consent.
                            </p>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default withRouter(Checkout);
